import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
const OnboardingFlow = lazy(() => import('../pages/OnboardingFlow').then(m => ({
  default: m.OnboardingFlow
})));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
const UploadPage = lazy(() => import('../pages/UploadPage').then(m => ({
  default: m.UploadPage
})));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage').then(m => ({
  default: m.AnalysisPage
})));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({
  default: m.ProfilePage
})));
const AllScansPage = lazy(() => import('../pages/AllScansPage').then(m => ({
  default: m.AllScansPage
})));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then(m => ({
  default: m.SettingsPage
})));
const MonthlyReportPage = lazy(() => import('../pages/MonthlyReportPage').then(m => ({
  default: m.MonthlyReportPage
})));
const PremiumToolsPage = lazy(() => import('../pages/PremiumToolsPage').then(m => ({
  default: m.PremiumToolsPage
})));
const MessageRewriterPage = lazy(() => import('../pages/MessageRewriterPage').then(m => ({
  default: m.MessageRewriterPage
})));
const PaymentPage = lazy(() => import('../pages/PaymentPage').then(m => ({
  default: m.PaymentPage
})));
export const protectedRoutes = <Fragment data-id="element-10897">
    <Route path="/onboarding" element={<ProtectedRoute data-id="element-10899">
          <OnboardingFlow data-id="element-10900" />
        </ProtectedRoute>} data-id="element-10898" />
    <Route path="/dashboard" element={<ProtectedRoute data-id="element-10902">
          <DashboardPage data-id="element-10903" />
        </ProtectedRoute>} data-id="element-10901" />
    <Route path="/upload" element={<ProtectedRoute data-id="element-10905">
          <UploadPage data-id="element-10906" />
        </ProtectedRoute>} data-id="element-10904" />
    <Route path="/analysis" element={<ProtectedRoute data-id="element-10908">
          <AnalysisPage data-id="element-10909" />
        </ProtectedRoute>} data-id="element-10907" />
    <Route path="/tools" element={<ProtectedRoute data-id="element-10911">
          <PremiumToolsPage data-id="element-10912" />
        </ProtectedRoute>} data-id="element-10910" />
    <Route path="/tools/rewriter" element={<ProtectedRoute data-id="element-10914">
          <MessageRewriterPage data-id="element-10915" />
        </ProtectedRoute>} data-id="element-10913" />
    <Route path="/premium-tools" element={<ProtectedRoute data-id="element-10917">
          <PremiumToolsPage data-id="element-10918" />
        </ProtectedRoute>} data-id="element-10916" />
    <Route path="/profile" element={<ProtectedRoute data-id="element-10920">
          <ProfilePage data-id="element-10921" />
        </ProtectedRoute>} data-id="element-10919" />
    <Route path="/all-scans" element={<ProtectedRoute data-id="element-10923">
          <AllScansPage data-id="element-10924" />
        </ProtectedRoute>} data-id="element-10922" />
    <Route path="/monthly-report" element={<ProtectedRoute data-id="element-10926">
          <MonthlyReportPage data-id="element-10927" />
        </ProtectedRoute>} data-id="element-10925" />
    <Route path="/settings" element={<ProtectedRoute data-id="element-10929">
          <SettingsPage data-id="element-10930" />
        </ProtectedRoute>} data-id="element-10928" />
    <Route path="/payment" element={<ProtectedRoute data-id="element-10932">
          <PaymentPage data-id="element-10933" />
        </ProtectedRoute>} data-id="element-10931" />
  </Fragment>;